import useSWR from 'swr'
import { kuroApi } from '@/modules/kuro/api'
import type { KuroOverviewData } from '@/modules/kuro/types'
import type { DataSnapshot } from '@/lib/schemas/snapshot'
import { fetcher } from '@/lib/swr'

export interface UseKuroOverviewResult {
  data: KuroOverviewData | undefined
  isLoading: boolean
  isError: boolean
  error: Error | undefined
  mutate: () => void
}

export function useKuroOverview(): UseKuroOverviewResult {
  const { data: snapshot, error, isLoading, mutate } = useSWR<DataSnapshot<KuroOverviewData>>(
    kuroApi.overview(),
    fetcher,
    { refreshInterval: 300000 } // 5 minutes
  )

  return {
    data: snapshot?.data,
    isLoading,
    isError: !!error,
    error: error || undefined,
    mutate,
  }
}
